export const microserviceApiRoutes = {
  v1: {
    claim: {
      auth: {
        login: () => "/api/v1/claim/auth",
        me: () => "/api/v1/claim/user",
      },
      device: {
        list: () => `/api/v1/claim/device`,
      },
      plan: {
        list: (deviceID: string | number | undefined) =>
          `/api/v1/claim/plan/${deviceID}`,
      },
      coverage: {
        list: (planId: string | number | undefined) =>
          `/api/v1/claim/coverage/${planId}`,
      },
      documents: {
        list: (coverageId: string | number | undefined) =>
          `/api/v1/claim/documents/${coverageId}`,
        uploadTotalDamage: (stageID: string) =>
          `/api/v1/claim/stage/documents/list/${stageID}`,
        uploadDocuments: (stageID: number) =>
          `/api/v1/claim/stage/documents/upload/${stageID}`,
      },
      create: () => "/api/v1/claim/create",
      code: {
        generate: () => "/api/v1/claim/generate-code",
        validate: () => "/api/v1/claim/validate-code",
      },
      list: () => `/api/v1/claim/list`,
      states: (reclamationID: number) => `/api/v1/claim/state/${reclamationID}`,
    },
    shared: {
      gender: {
        list: () => "/api/v1/shared/gender",
      },
      city: {
        list: () => "/api/v1/shared/cities",
      },
    },
    advisory: {
      create: () => "/api/v1/acinco/advisory",
    },
    enel: {
      auth: () => "/api/v1/acinco/auth/login",
      me: () => "/api/v1/acinco/enel/me",
      imei: () => "/api/v1/acinco/enel/imei",
      touchID: () => "/api/v1/acinco/enel/touchID",
      infoTouchID: () => "/api/v1/acinco/enel/info/touchID",
      create: () => "/api/v1/acinco/enel/create",
      recovery: () => "/api/v1/acinco/enel/recovery",
    },
    devices: {
      models: {
        get: () => "/api/v1/acinco/devices/models",
      },
      manufacturers: {
        get: () => "/api/v1/acinco/devices/manufacturers",
      },
      policies: {
        get: () => "/api/v1/acinco/devices/policies",
      },
      verify: () => "/api/v1/acinco/devices/verify",
    },
    agents: {
      auth: {
        login: () => "/api/v1/acinco/auth/agents/login",
        changePassword: () => "/api/v1/acinco/auth/agents/changePassword",
      },
      policy: {
        create: () => "/api/v1/acinco/agents/create/policy",
        preCreate: () => "/api/v1/acinco/agents/enel/pregeneratepolicy",
        preCreatePayment: () => "/api/v1/acinco/agents/pregenerate/policy",
        purchaseRecurrent: () => "/api/v1/acinco/agents/purchase",
        getStatusPurchaseAgent: (sessionTransaction: string) =>
          `/api/v1/acinco/agents/transaction-status/${sessionTransaction}`,
      },
      user: {
        me: () => "/api/v1/acinco/agents/me",
        list: () => "/api/v1/acinco/agents/list",
        getByID: (id: string) => `/api/v1/acinco/agents/${id}`,
        update: (id: string) => `/api/v1/acinco/agents/update/${id}`,
        create: () => "/api/v1/acinco/agents/create",
        changeStatus: () => `/api/v1/acinco/agents/changeStatus`,
      },
      roles: {
        list: () => "/api/v1/acinco/agents/roles/list",
      },
      touch: {
        create: () => "/api/v1/acinco/agents/touchID/create",
        verify: () => "/api/v1/acinco/agents/touchID/verify",
      },
      sponsors: {
        list: () => "/api/v1/acinco/agents/sponsors/list",
        create: () => "/api/v1/acinco/agents/sponsors/create",
        claimsPage: () => "/api/v1/acinco/agents/sponsors/claims-page",
        getBySlug: (slug: string) => `/api/v1/acinco/agents/sponsors/${slug}`,
      },
      plans: {
        getList: (sponsorID: string | number | undefined) =>
          `/api/v1/acinco/agents/enel/getPlans/${sponsorID}`,
      },
      devices: {
        verify: () => "/api/v1/acinco/agents/enel/verifyDevices",
      },
      // Electrodomésticos / "otro dispositivo" (MacCenter). Igual que el
      // resto de `agents.*`, usan el JWT de agente (interceptor del axios
      // compartido), no un token de sponsor aparte.
      appliances: {
        categories: () => "/api/v1/acinco/agents/appliances/categories",
        manufacturers: () => "/api/v1/acinco/agents/appliances/manufacturers",
        models: () => "/api/v1/acinco/agents/appliances/models",
        quoteByModel: (modelReference: string) =>
          `/api/v1/acinco/agents/appliances/policy/model/${modelReference}`,
        quoteFree: () => "/api/v1/acinco/agents/appliances/policy/free",
        policyBySerial: (serial: string) =>
          `/api/v1/acinco/agents/appliances/policy/serial/${serial}`,
        policyById: (policyId: string | number) =>
          `/api/v1/acinco/agents/appliances/policy/${policyId}`,
        policy: {
          create: () => "/api/v1/acinco/agents/appliances/policy",
          pregeneration: () =>
            "/api/v1/acinco/agents/appliances/policy/pregeneration",
        },
      },
    },
    policy: {
      auth: {
        login: (clientId: string) =>
          `/api/v1/acinco/agents/samsung/login?clientId=${clientId}`,
      },
    },
  },
};
